import { useEffect, useState } from "preact/hooks"

import {get} from "../utils/http"
import { useInterval } from "../utils/hooks"
import { allAgendas } from "./data/agendas"


export const isMember = window.dataLayer[0]["Registration Type"] !== "Non Member"
export const nonMemberUrls = /\/atrium|\/exhibition-hall(\-\w+)*/
export const auditoriumCloseDate = new Date("2023-10-24 14:00:00+0200")

export const getJaaSToken = async () => {
	const [{
		"Registrant ID": id,
		"First & Last Name": name,
		"Email Address": email,
		"Please make it more personal by uploading a head and shoulders photo:": avatar,
	}] = window.dataLayer
	const response = await get(
		"https://isf2021.swoogo-retrofit.tkevents.io/rt/getToken",
		{avatar, email, id, name},
	)

	if (!response.token) {
		throw response
	} else {
		return response.token
	}
}

export const useDate = () => {
	const now = new Date()
	const [year, updateYear] = useState(now.getUTCFullYear())
	const [month, updateMonth] = useState(now.getUTCMonth())
	const [date, updateDate] = useState(now.getUTCDate())

	// Really this should set up setTimeouts to update but I'M IN A RUSH
	useInterval(() => {
		const newNow = new Date()
		updateYear(newNow.getUTCFullYear())
		updateMonth(newNow.getUTCMonth())
		updateDate(newNow.getUTCDate())
	}, 1000 * 60 * 5)
	return {year, month, date}
}

export const useTime = () => {
	const now = new Date()
	const [hours, updateHours] = useState(now.getUTCHours())
	const [minutes, updateMinutes] = useState(now.getUTCMinutes())
	const [seconds, updateSeconds] = useState(now.getUTCSeconds())

	// Really this should set up setTimeouts to update but I'M IN A RUSH
	useInterval(() => {
		const newNow = new Date()
		updateHours(newNow.getUTCHours())
		updateMinutes(newNow.getUTCMinutes())
		updateSeconds(newNow.getUTCSeconds())
	}, 5000)
	return {hours, minutes, seconds}
}

export const useDateTime = (resolution = "minute") => {
	const [time, updateTime] = useState(new Date())
	
	useEffect(() => window.setInterval(
		() => updateTime(new Date()),
		resolution === "day" ? 86400000
		: resolution === "hour" ? 3600000
		: resolution === "minute" ? 60000
		: 1000 // 1 second
	), [resolution])

	return time
}

export const useDayOfEvent = () => {
	const {date} = useDate()

	// Event starts on the 25th which is day 1, so we
	// subtract 24 from the date, and then modulo 5
	return date % 5 + 1
}

export const useSession = () => {
	const now = useDateTime()

	const location = window.location.hash.replace(/^#/g, "")
	const currentSession = allAgendas.find(session => 
		session.path === location
		&& new Date(session.start) < now
		&& new Date(session.end) > now
	)

	return currentSession
}

export const mapAgendas = (day, string) => {
	const regex = /(\d{4}\-\d{2}\-\d{2}\s.*\+0200)\s-\s(\d{4}\-\d{2}\-\d{2}\s.*\+0200)\s(.*)/
	return string.split("\n").map(it => {
		return it.replace(/(\d{2}:\d{2})/g, `${day} $1:00+0200`)
			.replace("\t", " ")
			.split(regex)
			.filter(it => it !== "")
	})
}
